import React, { useState, useMemo } from 'react';
import T from 'prop-types';
// components
// import ClassCode from 'components/ClassCode';
import Typography from 'components/Typography';
import Select, { components } from 'react-select';
// icons
import { ReactComponent as IndicatorIcon } from 'icons/chevron.svg';
// styles
import classnames from 'classnames/bind';
import styles from './ClassSelect.module.scss';

const cx = classnames.bind(styles);

const customStyles = {
  option: (provided) => ({
    ...provided,
    backgroundColor: 'white',
    border: `1px solid #a0a2af`,
    borderTop: 'none',
    color: 'black',
    cursor: 'pointer',
    transition: 'all .2s ease',
    '&:hover': {
      backgroundColor: '#F3F3F5',
    },
    '&:last-child': {
      borderRadius: '0px 0px 4px 4px',
    },
    padding: '0',
  }),
  control: (provided, state) => ({
    ...provided,
    width: '530px',
    border: `1px solid #a0a2af`,
    borderRadius: state.menuIsOpen ? '2px 2px 0 0' : '2px',
    transition: 'boxShadow .2s ease',
    boxShadow: state.menuIsOpen ? '0px 4px 8px rgba(0, 0, 0, 0.25)' : 'none',
    '&:hover': {
      borderColor: '#a0a2af',
    },
    padding: '2px 5px',
    cursor: 'pointer',
  }),
  menu: (provided) => ({
    ...provided,
    boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.25)',
    margin: 0,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: 0,
  }),
  indicatorSeparator: () => ({}),
  placeholder: (provided) => ({
    ...provided,
    fontSize: '22px',
    color: '#267992',
  }),
};

const ClassSelect = ({ onChange, options = [] }) => {
  const [value, setValue] = useState();

  const DropdownIndicator = (dprops) => (
    <components.DropdownIndicator {...dprops}>
      <IndicatorIcon
        className={cx('indicator-icon', {
          open: dprops.selectProps.menuIsOpen,
        })}
      />
    </components.DropdownIndicator>
  );

  const Option = (oprops) => (
    <components.Option {...oprops}>
      <div className={cx('option-wrapper')}>
        <div role="row" className={cx('option')}>
          <Typography className={cx('name')} title={oprops.data?.name}>
            {oprops.data?.name}
          </Typography>
          {/* <ClassCode className={cx('code', 'mgl-auto')} code={oprops.data?.code} /> */}
        </div>
      </div>
    </components.Option>
  );

  const lsClassId = localStorage.getItem('class-id');
  const defaultValue = useMemo(() => options.find(({ id }) => +id === +lsClassId) || options[0], [options, lsClassId]);

  return (
    <Select
      styles={customStyles}
      options={options}
      value={value || defaultValue}
      onChange={(val) => {
        onChange?.(val);
        setValue(val);
      }}
      getOptionValue={(option) => `${option.name} ${option.code}`}
      getOptionLabel={(option) => (
        <div role="row" className={cx('value')}>
          <Typography className={cx('name')} title={option.name}>
            {option.name}
          </Typography>
          {/* <ClassCode className={cx('code', 'mgl-auto')} code={option.code} /> */}
        </div>
      )}
      components={{ DropdownIndicator, Option }}
      isSearchable={false}
      placeholder="No Class Selected"
    />
  );
};

ClassSelect.propTypes = {
  onChange: T.func.isRequired,
  options: T.arrayOf(T.object),
};

export default ClassSelect;
